import { masterAxios } from 'api/config'
import { store } from 'store/index'
import { appVersionActions } from 'store/app-version'
import { BUILD_TYPE } from 'config'
import { AppVersion } from 'types/app-version'
import { useCallback } from 'react'

export const useAppVersion = () => {
  const reloadWindowAndClearServiceWorker = useCallback(() => {
    console.debug('Reloading window and clearing service worker...')
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        return Promise.all(registrations.map((r) => r.unregister()))
      })
      .then(() => window.location.reload())
  }, [])

  const getLastPipelineVersion = useCallback(async () => {
    try {
      const { data: newPipelineVersion } = await masterAxios.get<AppVersion>(`app-versions/last/${BUILD_TYPE}`)
      console.debug({ newPipelineVersion })
      store.dispatch(appVersionActions.setLastPipelineVersion(newPipelineVersion.version))
    } catch (e) {
      console.error({ getLastPipelineVersionError: e })
    }
  }, [])

  return {
    getLastPipelineVersion,
    reloadWindowAndClearServiceWorker,
  }
}
